import { ISession } from '../../models/session';
import { Injectable } from '@angular/core';
import { environment as config } from '../../../environments/environment';
import { AuthHttp } from 'angular2-jwt';
import { AuthService } from '../auth/auth.service';
import { BasicService } from '../../providers/basic';
import { TranslateService } from '@ngx-translate/core';
import { Headers } from '@angular/http';

@Injectable()
export class TagsService extends BasicService {
  private TAGS_API = config.tags.url;
  constructor(
    protected auth: AuthService,
    protected translate: TranslateService,
    private http: AuthHttp
  ) {
    super(auth, translate);
  }

  public getTag(session: ISession, tag: string) {
    return this.http
      .get(`${this.TAGS_API}/tags/${session.id}/name/${tag}?language=${session.language}`)
      .map(res => {
        return this.extractData(res, false);
      })
      .catch(err => this.handleError(err));
  }

  public updateTag(session: ISession, tag: any) {
    return this.http
      .put(`${this.TAGS_API}/tags/${session.id}?language=${session.language}`, tag, {
        headers: this.apiTokenHeaders()
      })
      .map(res => this.extractData(res, false));
  }

  private apiTokenHeaders(): Headers {
    const headers = new Headers();
    headers.append('X-Api-Token', AuthService.retrieve(AuthService.API_TOKEN_KEY));
    return headers;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/tags.service.ts